export function orderCancellationMessage(response) {
  const data = response && response.data
  const recoveryFailed = data && (data.rewardRecoveryFailed === true ||
    (Array.isArray(data.failedRewardLogIds) && data.failedRewardLogIds.length > 0))
  return {
    type: recoveryFailed ? 'warning' : 'success',
    message: recoveryFailed
      ? (response.message || '订单已取消，但部分赠送奖励回收失败，请查看赠送流水处理。')
      : '取消成功!'
  }
}
